import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import * as actions from '../../features/data-connector/redux/actions';
import * as commonActions from '../../features/common/redux/actions';
import ExternalSourceHeaderNav from '../../common/headerNav/ExternalSourceHeaderNav';
import { ParentContentCardMultiHeader } from '../common/ParentContentCardMultiHeader';
import { externalDataGrouping } from './connectorUtils';
import Swal from 'sweetalert2';
import {
  APP_WRITE,
  DIRECTUS,
  SUPABASE,
  XANO,
  XATA,
  AIRTABLE,
  SALESFORCE,
  DRAPCODE,
  DATA_SOURCE,
  MYSQL,
} from 'drapcode-constant';
import DataSourceLinks from './DataSourceLinks';
import CommonPageComponent from '../../common/ui/CommonPageComponent';
import CustomLoader from '../common/CustomLoader';
import { showAlertHtmlWithFeedback } from '../../common/utils/alert';
import { extractFieldSupaBase, transformCollectionsAppwrite } from './utils';
import { filterCollections, filterXanoCollection } from './common/common_utils';
import TooltipInfo from '../../common/docs/TooltipInfo';
import { description } from '../../common/utils/event_constants';
import { checkDataSourcePermission } from '../../common/utils/permissions';
import PermissionDenied from '../../common/PermissionDenied';
import { Link } from 'react-router-dom';
import { drapcodeIcon } from '../../common/custom/icon-library';
import { Modal, ModalBody, ModalHeader } from 'reactstrap';
import ExternalDbSettingForm from './ExternalDbSettingForm';

export class DefaultPage extends Component {
  static propTypes = {
    dataConnector: PropTypes.object.isRequired,
    home: PropTypes.object.isRequired,
    actions: PropTypes.object.isRequired,
  };

  state = {
    activeTab: DRAPCODE,
    headers: [],
    refreshActionLoaderIndex: null,
  };

  async componentDidMount() {
    const { match, actions } = this.props;
    const { projectId, version } = match.params;
    let connectorType = DRAPCODE;
    const headers = [];
    await actions.getExternalDataBase({ projectId, version });
    actions.getPermissionFlags({ projectId });
    this.setState({ activeTab: connectorType, headers });
    actions.loadProjectDetail({ projectId, version });
  }
  componentDidUpdate(prevProps) {
    const { projectDetail } = this.props.common;
    if (prevProps.common.projectDetail !== projectDetail) {
      if (projectDetail && projectDetail.projectType) {
        const { projectType } = projectDetail;
      }
    }
  }
  toggle = (tab) => {
    this.setState({ activeTab: tab });
  };
  toggleOpenExternalDbSettingModal = (entry) => {
    const { actions } = this.props;
    actions.openExternalDbSettingModal(entry || null);
  };
  renderExternalDbSettingModal = () => {
    const { dataConnector } = this.props;
    const { isOpenExternalDbSettingModal, selectedExternalDb } = dataConnector;
    const entry = selectedExternalDb || {};
    if (!entry || Object.keys(entry).length === 0) {
      return null;
    }
    const { name, type, setting } = entry || {};
    return (
      <Modal
        size="lg"
        isOpen={isOpenExternalDbSettingModal}
        toggle={() => this.toggleOpenExternalDbSettingModal()}
        backdrop="static"
      >
        <ModalHeader
          toggle={() => this.toggleOpenExternalDbSettingModal()}
          className="border-bottom"
        >
          {name}'s Account Details
        </ModalHeader>
        <ModalBody>
          <div className="row">
            <div className="col-md-12">
              <ExternalDbSettingForm
                dataConnector={dataConnector}
                type={type}
                dataSourceName={name}
                settingData={setting}
              />
            </div>
          </div>
        </ModalBody>
      </Modal>
    );
  };
  handleDelete = async (entry) => {
    const { match, actions } = this.props;
    const { projectId, version } = match.params;
    const { uuid: externalDatabaseId, type, name } = entry || {};
    //Fetch Linked Collections
    await actions.loadProjectExternalDbCollections({
      projectId,
      version,
      externalDatabaseId,
    });
    const { collectionsExternalDataSources } = this.props.dataConnector;
    let linkedComponents = {};
    let dataExists = false;
    dataExists = collectionsExternalDataSources && collectionsExternalDataSources.length > 0;

    linkedComponents['Collections'] = collectionsExternalDataSources
      ? collectionsExternalDataSources.length
      : 0;
    //Fetch Linked Events
    if (!dataExists) {
      await actions.loadEventsExternalDataSource({
        projectId,
        version,
        externalDatabaseId,
      });
      const { eventsExternalDataSources } = this.props.dataConnector;
      dataExists = eventsExternalDataSources && eventsExternalDataSources.length > 0;
      linkedComponents['Events'] = eventsExternalDataSources ? eventsExternalDataSources.length : 0;
    }
    //Fetch Linked External APIs
    if (!dataExists) {
      await actions.loadExternalApisExternalDb({
        projectId,
        version,
        externalDatabaseId,
      });
      const { externalApisExternalDataSources } = this.props.dataConnector;
      dataExists = externalApisExternalDataSources && externalApisExternalDataSources.length > 0;
      linkedComponents['ExternalAPIs'] = externalApisExternalDataSources
        ? externalApisExternalDataSources.length
        : 0;
    }

    console.log('🚀 ~ DefaultPage ~ linkedComponents:', linkedComponents);

    dataExists = Object.values(linkedComponents).some((count) => count > 0);

    if (dataExists) {
      const confirmationMsg = `
      <div style="text-align: left;">
        <strong>Warning:</strong> Data Source (<b>${name}</b>) is linked to Collections, Events, and External APIs.
      </div>
      <br/>
      <ol class="px-3" style="text-align: left; font-size: 14px;">
        <li class="mb-2">All linked <b>Collections</b> will be permanently deleted.</li>
        <li class="mb-2">All linked <b>Events</b> will be permanently deleted.</li>
        <li class="mb-2">All linked <b>External APIs</b> will be permanently deleted.</li>
      </ol>
      <p style="text-align: left;">
        <b>Note:</b> This action will <span class="text-danger">irreversibly delete</span> the Data Source and all its linked resources.
      </p>
      <br/>
      <div>
        Are you sure you want to continue?
      </div>
      `;
      const feedbackTitle = `Deleted!`;
      const feedbackIcon = `success`;
      const feedbackMsg = `Data Source has been deleted.`;

      const preConfirm = async () => {
        await actions.deleteExternalDatabase({ projectId, version, externalDatabaseId, type });
        await actions.getExternalDataBase({ projectId, version });
      };

      const feedbackData = {
        feedbackTitle,
        feedbackIcon,
        feedbackHtml: feedbackMsg,
      };

      showAlertHtmlWithFeedback(confirmationMsg, preConfirm, 'Yes, delete it!', feedbackData);
    } else {
      const confirmationMsg = `This action will delete the Data Source along with it's configuration.`;
      const feedbackTitle = `Deleted!`;
      const feedbackIcon = `success`;
      const feedbackMsg = `DataSource has been deleted.`;

      const preConfirm = async () => {
        await actions.deleteExternalDatabase({ projectId, version, externalDatabaseId, type });
        await actions.getExternalDataBase({ projectId, version });
      };

      const feedbackData = {
        feedbackTitle,
        feedbackIcon,
        feedbackHtml: feedbackMsg,
      };

      showAlertHtmlWithFeedback(confirmationMsg, preConfirm, 'Yes, delete it!', feedbackData);
    }
  };
  renderDatabaseCell = (entry) => {
    const { completeData } = entry || {};
    const { database } = completeData || {};
    if (database) {
      return database;
    } else {
      return '_ _';
    }
  };
  renderNumberOfTablesCell = (entry) => {
    const { completeData } = entry || {};
    const { tables } = completeData || {};
    if (tables && typeof tables === 'object' && Array.isArray(tables)) {
      return `${tables.length} tables`;
    } else if (tables && typeof tables === 'object' && !Array.isArray(tables)) {
      return `${Object.keys(tables).length} tables`;
    } else {
      return '0';
    }
  };
  renderDataSourceName = (entry) => {
    return entry.name;
  };
  renderDataSourceType = (entry) => {
    const sourceType = entry.type;
    return this.formatSourceType(sourceType);
  };
  renderConfigButton = (entry) => {
    const { updateTablesAndFieldsPending } = this.props.dataConnector;
    const sourceType = entry.type;
    switch (sourceType) {
      case MYSQL:
        return (
          <>
            <button
              className="btn btn-xs btn-primary"
              disabled={updateTablesAndFieldsPending}
              onClick={() => this.toggleOpenExternalDbSettingModal(entry)}
            >
              <i className="wb webconnect-cog" title="Account Details"></i>
            </button>
            &nbsp;
          </>
        );
      default:
        return (
          <>
            <button className="btn btn-xs btn-disabled" disabled={true}>
              <i className="wb webconnect-cog" title="Account Details"></i>
            </button>
            &nbsp;
          </>
        );
    }
  };
  renderRefreshButton = (entry) => {
    const { updateTablesAndFieldsPending, syncMySqlDataSourceTablesPending } =
      this.props.dataConnector;
    const { refreshActionLoaderIndex } = this.state;
    return (
      <>
        <button
          className="btn btn-xs btn-theme-green"
          disabled={
            (updateTablesAndFieldsPending || syncMySqlDataSourceTablesPending) &&
            refreshActionLoaderIndex === entry.uuid
          }
          onClick={() => this.handleUpdateDataSources(entry.uuid, entry.type, entry.setting, entry)}
        >
          <i className="wb webconnect-refresh" title="Refresh"></i>
        </button>
        &nbsp;
      </>
    );
  };
  renderEditLink = (entry) => {
    const { match } = this.props;
    const { projectId, version } = match.params;
    const { uuid, type } = entry || {};

    switch (type) {
      case APP_WRITE:
        return (
          <>
            <Link
              to={`/2.0/data-connector/${version}/v/${projectId}/appwrite-edit/${uuid}`}
              className="btn btn-primary btn-xs"
              title="Edit"
            >
              <i className={`wb ${drapcodeIcon('edit')}`} />
            </Link>
            &nbsp;
          </>
        );
      case SUPABASE:
        return (
          <>
            <Link
              to={`/2.0/data-connector/${version}/v/${projectId}/supabase-edit/${uuid}`}
              className="btn btn-primary btn-xs"
              title="Edit"
            >
              <i className={`wb ${drapcodeIcon('edit')}`} />
            </Link>
            &nbsp;
          </>
        );
      case XATA:
        return (
          <>
            <Link
              to={`/2.0/data-connector/${version}/v/${projectId}/xata-edit/${uuid}`}
              className="btn btn-primary btn-xs"
              title="Edit"
            >
              <i className={`wb ${drapcodeIcon('edit')}`} />
            </Link>
            &nbsp;
          </>
        );
      case DIRECTUS:
        return (
          <>
            <Link
              to={`/2.0/data-connector/${version}/v/${projectId}/directus-edit/${uuid}`}
              className="btn btn-primary btn-xs"
              title="Edit"
            >
              <i className={`wb ${drapcodeIcon('edit')}`} />
            </Link>
            &nbsp;
          </>
        );
      case AIRTABLE:
        return (
          <>
            <Link
              to={`/2.0/data-connector/${version}/v/${projectId}/airtable-edit/${uuid}`}
              className="btn btn-primary btn-xs"
              title="Edit"
            >
              <i className={`wb ${drapcodeIcon('edit')}`} />
            </Link>
            &nbsp;
          </>
        );
      case SALESFORCE:
        return (
          <>
            <Link
              to={`/2.0/data-connector/${version}/v/${projectId}/salesforce-update/${uuid}`}
              className="btn btn-primary btn-xs"
              title="Edit"
            >
              <i className={`wb ${drapcodeIcon('edit')}`} />
            </Link>
            &nbsp;
          </>
        );
      case MYSQL:
        return (
          <>
            <Link
              to={`/2.0/data-connector/${version}/v/${projectId}/mysql-datasource/${uuid}/edit`}
              className="btn btn-primary btn-xs"
              title="Edit"
            >
              <i className={`wb ${drapcodeIcon('edit')}`} />
            </Link>
            &nbsp;
          </>
        );
      default:
        return (
          <>
            <Link
              to={`/2.0/data-connector/${version}/v/${projectId}/external-database-edit/${uuid}`}
              className="btn btn-primary btn-xs"
              title="Edit"
            >
              <i className={`wb ${drapcodeIcon('edit')}`} />
            </Link>
            &nbsp;
          </>
        );
    }
  };
  renderDeleteButton = (entry) => {
    const { permissionFlags } = this.props.dataConnector;
    let flag;

    if (permissionFlags && permissionFlags.length > 0) {
      flag = permissionFlags.includes(DATA_SOURCE);
    }
    return (
      <button
        className="btn btn-xs btn-theme-delete"
        style={{ cursor: flag ? 'pointer' : 'not-allowed' }}
        onClick={() => (flag ? this.handleDelete(entry) : undefined)}
      >
        <i className="wb webconnect-trash-solid" title="Delete"></i>
        {flag ? null : (
          <>
            &nbsp;
            <TooltipInfo
              title={description}
              headerText={`Permission Disabled!`}
              showHeader={true}
              showArrow={true}
            />
          </>
        )}
      </button>
    );
  };
  renderTableRow = (entry) => {
    const { syncMySqlDataSourceTablesPending } = this.props.dataConnector;
    const { refreshActionLoaderIndex } = this.state;
    return (
      <tr className="text-left td-align-middle" key={entry.uuid}>
        <td>{this.renderDataSourceName(entry)}</td>
        <td>{this.renderDataSourceType(entry)}</td>
        <td>{this.renderDatabaseCell(entry)}</td>
        <td>
          {syncMySqlDataSourceTablesPending && refreshActionLoaderIndex === entry.uuid ? (
            <i className="fa fa-spinner fa-spin"></i>
          ) : (
            this.renderNumberOfTablesCell(entry)
          )}
        </td>
        <td className="text-right">
          {this.renderConfigButton(entry)}
          {this.renderRefreshButton(entry)}
          {this.renderEditLink(entry)}
          {this.renderDeleteButton(entry)}
        </td>
      </tr>
    );
  };

  handleUpdateDataSources = async (dbUuid, type, setting, item) => {
    const { actions, match } = this.props;
    const { projectId, version } = match.params;
    const showConfirmation = async () => {
      return Swal.fire({
        title: 'Are you sure?',
        text: `This action will retrieve the latest details from your specified ${this.formatSourceType(
          type,
        )} account.`,
        icon: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#d33',
        confirmButtonText: 'Yes, proceed!',
        cancelButtonText: 'Cancel',
      });
    };

    switch (type) {
      case SUPABASE:
        const supabaseConfirmation = await showConfirmation();
        if (supabaseConfirmation.isConfirmed) {
          await this.handleSupabaseTables(dbUuid, setting);
        }
        break;
      case APP_WRITE:
        const appwriteConfirmation = await showConfirmation();
        if (appwriteConfirmation.isConfirmed) {
          await this.handleAppwriteTables(dbUuid, setting, item);
        }
        break;
      case DIRECTUS:
        const directusConfirmation = await showConfirmation();
        if (directusConfirmation.isConfirmed) {
          await this.handleDirectusTables(dbUuid, setting, item);
        }
        break;
      case XANO:
        const xanoConfirmation = await showConfirmation();
        if (xanoConfirmation.isConfirmed) {
          await this.handleXanoTables(dbUuid, setting, item);
        }
        break;
      case MYSQL:
        const mysqlConfirmation = await showConfirmation();
        if (mysqlConfirmation.isConfirmed) {
          this.setState({ refreshActionLoaderIndex: dbUuid });
          await this.handleMySqlTables(dbUuid);
          this.setState({ refreshActionLoaderIndex: null });
        }
        break;
      default:
        const externalDBConfirmation = await showConfirmation();
        if (externalDBConfirmation.isConfirmed) {
          await actions.getExternalDataBase({ projectId, version });
        }
        break;
    }
  };
  handleSupabaseTables = async (dbUuid, setting) => {
    const { match, actions } = this.props;
    const { projectId, version } = match.params;
    const { supabase_key, dataBaseUrl } = setting;
    await actions.getSupabaseData({
      developerKey: supabase_key,
      dataBaseUrl,
      projectId,
      version,
    });
    const { dataConnector } = this.props;
    const { supabaseData } = dataConnector || '';
    let supabaseCollectionTables = '';
    supabaseCollectionTables = extractFieldSupaBase(supabaseData);
    await actions.updateTablesAndFields({
      projectId,
      version,
      dbUuid,
      data: supabaseCollectionTables,
    });
    await actions.getExternalDataBase({ projectId, version });
  };
  handleAppwriteTables = async (dbUuid, setting, item) => {
    const { match, actions } = this.props;
    const { projectId, version } = match.params;
    const { completeData } = item ? item : '';
    const { database } = completeData ? completeData : '';
    const { id } = database ? database : '';
    await actions.getCollectionsByAppwrite({
      settingData: setting,
      databaseId: id,
      version,
      projectId,
    });
    const { dataConnector } = this.props;
    const { collectionsByAppwrite } = dataConnector || '';
    const { collections } = collectionsByAppwrite ? collectionsByAppwrite : '';
    const transformedResult = transformCollectionsAppwrite(collections);
    await actions.updateTablesAndFieldsAppwrite({
      projectId,
      version,
      dbUuid,
      data: transformedResult,
    });
    await actions.getExternalDataBase({ projectId, version });
  };
  handleDirectusTables = async (dbUuid, setting, item) => {
    const { match, actions } = this.props;
    const { projectId, version } = match.params;
    const { Authorization, baseUrl } = setting ? setting : '';
    let clearToken = Authorization.replace('Bearer ', '');
    await actions.getCollectionsForDirectus({ projectId, version, baseUrl, userToken: clearToken });

    if (this.props.dataConnector.collectionByDirectus) {
      const collections = this.props.dataConnector.collectionByDirectus;
      const collectionNames = filterCollections(collections);
      await actions.updateDirectusTables({
        projectId,
        version,
        dbUuid,
        data: collectionNames,
      });
      await actions.getExternalDataBase({ projectId, version });
    }
  };
  handleXanoTables = async (dbUuid, setting, item) => {
    const { match, actions } = this.props;
    const { projectId, version } = match.params;
    const { xanoApiAccessToken } = setting ? setting : '';
    const { completeData } = item ? item : '';
    const { workspace } = completeData ? completeData : '';
    const { id } = workspace ? workspace : '';
    await actions.getXanoTable({ token: xanoApiAccessToken, projectId, id, version });
    if (this.props.dataConnector.xanoDataSourceTables) {
      const collections = this.props.dataConnector.xanoDataSourceTables;
      const collectionNames = filterXanoCollection(collections);
      await actions.updateDirectusTables({
        projectId,
        version,
        dbUuid,
        data: collectionNames,
      });
      await actions.getExternalDataBase({ projectId, version });
    }
  };
  handleMySqlTables = async (dbUuid) => {
    const { match, actions } = this.props;
    const { projectId, version } = match.params;

    await actions.syncMySqlDataSourceTables({
      projectId,
      version,
      dbUuid,
    });

    if (!this.props.dataConnector.syncMySqlDataSourceTablesPending) {
      await actions.getExternalDataBase({ projectId, version });
    }
  };

  formatSourceType(sourceType) {
    let formattedType =
      sourceType === MYSQL
        ? 'MySQL'
        : sourceType.charAt(0).toUpperCase() + sourceType.slice(1).toLowerCase();
    if (formattedType.includes('_')) {
      formattedType = formattedType.replace(/_/g, '');
    }
    return formattedType;
  }

  render() {
    const isAllowed = checkDataSourcePermission();
    if (!isAllowed) {
      return (
        <div className="main">
          <div className="section">
            <div className="container data-source">
              <PermissionDenied message="Data Source" />
            </div>
          </div>
        </div>
      );
    }
    const { match, dataConnector } = this.props;
    const { projectId, version } = match.params;
    const {
      externalDataBaseData,
      getExternalDataBasePending,
      isOpenExternalDbSettingModal,
      syncMySqlDataSourceTablesPending,
    } = dataConnector;
    const { headers, activeTab } = this.state;
    const data = externalDataGrouping(externalDataBaseData);
    return (
      <div className="main">
        <div className="section">
          <div className="container data-source">
            <ExternalSourceHeaderNav
              title="Data Source"
              titleIcon="data-source"
              projectId={projectId}
              version={version}
              headers={headers}
              activeTab={activeTab}
              enableRestApi={false}
              enableZapier={false}
              enableDrapcode={true}
              toggle={this.toggle}
            />
            {getExternalDataBasePending ? (
              <CommonPageComponent>
                <div className="text-center">
                  <CustomLoader loading={getExternalDataBasePending} size="20px" color="#303453" />
                </div>
              </CommonPageComponent>
            ) : (
              <div className="row mx-auto">
                <ParentContentCardMultiHeader
                  isSearch={false}
                  btnSize="sm"
                  handleSearch={this.handleSearch}
                  updateSearchTerm={this.updateSearchTerm}
                  title="Data Sources"
                  icon="data-source"
                  bgColor="drapcode-violet"
                  projectId={projectId}
                  version={version}
                  CtaComponent={<DataSourceLinks projectId={projectId} version={version} />}
                >
                  {getExternalDataBasePending ||
                    (syncMySqlDataSourceTablesPending && (
                      <div className="text-center">
                        <CustomLoader
                          loading={getExternalDataBasePending || syncMySqlDataSourceTablesPending}
                          size="20px"
                          color="#303453"
                        />
                      </div>
                    ))}
                  {externalDataBaseData ? (
                    <>
                      <div className="table-responsive">
                        <table className="table table-bordered table-hover table-sm table-word-break connector-list">
                          <thead>
                            <tr>
                              <th>Name</th>
                              <th>Source</th>
                              <th>Database</th>
                              <th>Number of Tables</th>
                              <th>Action</th>
                            </tr>
                          </thead>
                          <tbody>
                            {Object.keys(data).map((database) =>
                              data[database].map((entry) => this.renderTableRow(entry)),
                            )}
                          </tbody>
                        </table>
                      </div>
                      {isOpenExternalDbSettingModal && this.renderExternalDbSettingModal()}
                    </>
                  ) : (
                    <div className="col-md-12">
                      <h5 className="text-center">No Data Source Exist!</h5>
                    </div>
                  )}
                </ParentContentCardMultiHeader>
              </div>
            )}
          </div>
        </div>
      </div>
    );
  }
}

function mapStateToProps(state) {
  return {
    dataConnector: state.dataConnector,
    home: state.home,
    common: state.common,
  };
}
function mapDispatchToProps(dispatch) {
  return {
    actions: bindActionCreators({ ...actions, ...commonActions }, dispatch),
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(DefaultPage);
